import { AllergenDto } from './allergen.dto';
import { BaseDto } from './base.dto';
import { DiscountTypeDto } from './discountType.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantOrderNoteOptionDto } from './merchantOrderNoteOption.dto';
import { ProductCategoryDto } from './productCategory.dto';
import { ProductModifierGroupDto } from './productModifierGroup.dto';
import { ProductOutOfStockDto } from './productOutOfStock.dto';
import { StockDto } from './stock.dto';

export class ProductMenuModifierDto extends BaseDto {
  name: string;
  code?: string;
  photoURL?: string;
  photoURLBase64?: string;
  merchantId?: number;
  calorieCount?: number;
  preparationTime: number;
  price: number;
  VATRateId?: number;
  startDate?: Date;
  endDate?: Date;
  description: string;
  pointsGiven?: number;
  pointsRequired?: number;
  productCategory?: ProductCategoryDto;
  productModifierGroups: ProductModifierGroupDto[];
  allergens?: AllergenDto[];
  stock?: StockDto[];
  merchant: MerchantDto;
  printName?: string;
  orderNoteOptions?: MerchantOrderNoteOptionDto[];
  menuId?: number;
  isDiscountable?: boolean;
  isBundle?: boolean;
  bundleChecked?: boolean;
  bundleCombinationId?: string;
  quantity?: number; // UP-3817 - needed for re-open closed table.
  minPrice?: number;
  barCode?: string;
  hasGroupModifier?: boolean;
  menuCategoryColorCode?: string;
  sequence?: number;
  isOpenPrice: boolean;
  openPrice?: number;
  discountType?: DiscountTypeDto;
  clickedSequence?: number;
  tableSeat?: string;
  productsOutOfStock?: ProductOutOfStockDto[];
  cartProductStockSelected?: number;
  isAgeVerification: boolean;
  drsValue?: number;
}
